import styled from "styled-components";

export const Hours = styled.div``;
export const Hour = styled.div`
  display: flex;
  align-items: baseline;
`;
